/** 入驻商家类型 */
export const bidTypes = {
	2: '境内POP店铺',
	3: '一件代发供应商',
	4: '经销供应商',
	5: '代销供应商',
	6: '跨境平台服务',
	7: '个体工商户',
	8: '个人艺术家',
}
